import React, { useEffect, useState } from 'react';
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import './DetailsProduct.css'
import SinglePagenation from '../../../../components/general/pagination/SinglePagenation';

function PopupFiles({ open, setOpen, id, translate,files }) {
    const { dispatch, langLocal,navigate,mode } = AbstructVar()
    const [currentPage, setCurrentPage] = useState(0);
    const filesPerPage = 1; // عدد الملفات لكل صفحة
    const [tempFiles , setTempFiles] = useState([])
    useEffect(()=>{
        if(files && files?.length > 0){
            setTempFiles(files)
        }
    },[files])

    // حساب عدد الصفحات
    const pageCount = Math.ceil(tempFiles.length / filesPerPage);

    // حساب الفهرس الأول للملفات في الصفحة الحالية
    const indexOfLastFile = (currentPage + 1) * filesPerPage;
    const indexOfFirstFile = indexOfLastFile - filesPerPage;
    const currentFiles = tempFiles.slice(indexOfFirstFile, indexOfLastFile);

    const handlePageClick = ({ selected }) => {
        setCurrentPage(selected);
    };

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `pop_center ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div>
                {currentFiles.map((file, index) => (
                    <div className='file_pop'  key={index}>
                        <p>{file?.notes}</p>
                        <img src={file?.file_path} alt={file?.notes} />
                    </div>
                ))}
                <br></br>
                <br></br>
                <SinglePagenation pageCount={pageCount} changePage={handlePageClick} />
            </div>
        </RModal>
    );
}

export default PopupFiles;